// frontend/src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('admin@local.test');
  const [password, setPassword] = useState('admin');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      console.log('Tentative de connexion avec:', { email, password });

      const result = await login(email, password);
      console.log('Résultat login:', result);

      if (result.success) {
        const user = result.user;

        // 🔹 Super admin plateforme
        if (user?.permissions?.globalSuperAdmin) {
          console.log('Super admin détecté, redirection vers /admin/tenants');
          navigate('/admin/tenants', { replace: true });
          return;
        }

        // 🔹 Client final (adapte la condition au besoin)
        if (user?.role === 'client') {
          console.log('Client détecté, redirection vers /client/dashboard');
          navigate('/client/dashboard', { replace: true });
          return;
        }

        // 🔹 Cabinet (admin / collaborateur / autres)
        console.log('Utilisateur cabinet, redirection vers /dashboard');
        navigate('/dashboard', { replace: true });
      } else {
        setError(result.error || 'Erreur de connexion');
        console.log('Erreur login:', result.error);
      }
    } catch (err) {
      console.error('Erreur inattendue:', err);
      setError('Erreur inattendue lors de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Cabinet</h1>
          <p style={styles.subtitle}>Application de Gestion</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={submit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@local.test"
              type="email"
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Mot de passe</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="admin"
              required
            />
          </div>

          <button
            style={{ ...styles.button, ...(loading ? styles.buttonDisabled : {}) }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div style={styles.demo}>
          <strong>Compte admin :</strong> admin@local.test / admin
        </div>

        <div style={styles.debug}>
          <strong>Debug:</strong> Vérifiez la console pour les logs
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(45deg, #4F46E5, #7E22CE)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: 'Arial, sans-serif'
  },
  card: {
    background: 'white',
    borderRadius: '15px',
    padding: '40px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    width: '100%',
    maxWidth: '400px'
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px'
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#1F2937',
    margin: '0 0 8px 0'
  },
  subtitle: {
    fontSize: '16px',
    color: '#6B7280',
    margin: 0
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151'
  },
  input: {
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.2s'
  },
  button: {
    background: 'linear-gradient(45deg, #4F46E5, #7E22CE)',
    color: 'white',
    border: 'none',
    padding: '14px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '10px',
    transition: 'opacity 0.2s'
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  error: {
    background: '#FEF2F2',
    color: '#DC2626',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #FECACA',
    marginBottom: '20px',
    fontSize: '14px'
  },
  demo: {
    marginTop: '25px',
    padding: '15px',
    background: '#F3F4F6',
    borderRadius: '8px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#6B7280'
  },
  debug: {
    marginTop: '15px',
    padding: '10px',
    background: '#EFF6FF',
    borderRadius: '6px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#3B82F6'
  }
};
